<template>
  <div>
    <a-modal
      title="Novedades My Team"
      :visible="visible"
      width="90%"
      @ok="close"
      @cancel="close"
      :cancel-button-props="{ style: { display: 'none' } }"
    >
    <a-spin :spinning="loading">
      <a-tabs v-model:activeKey="activeTab">
        <a-tab-pane key="vacaciones" tab="Vacaciones">
          <div style="margin-bottom: 10px;">
            <a-range-picker v-model="dateRange"/>
            <a-button type="primary" @click="fetchData">Filtrar</a-button>
            <br>
          </div>

          <a-table
            :data-source="filteredData"
            :columns="vacacionesColumns"
            :pagination="{ pageSize: 5 }"
            bordered
            size="small"
            :rowKey="(record, index) => `${record.id_emp}-${index}`">
            <div
              slot="filterDropdown"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              style="padding: 8px"
            >
              <a-input
                v-ant-ref="c => (searchInput = c)"
                :placeholder="`Search ${column.dataIndex}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block;"
                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
              >
                Search
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                Reset
              </a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template slot="customRender" slot-scope="text, record, index, column">
                <span v-if="searchText && searchedColumn === column.dataIndex">
                  <template
                    v-for="(fragment, i) in (text || '')
                      .toString()
                      .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                    <mark
                      v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                      :key="i"
                      class="highlight">{{ fragment }}</mark>
                    <template v-else>{{ fragment }}</template>
                  </template>
                </span>
              <template v-else>
                {{ text }}
              </template>
            </template>
          </a-table>
        </a-tab-pane>

        <a-tab-pane key="cumpleanos" tab="Cumpleaños">
          <div style="margin-bottom: 10px;">
            <a-select
              v-model="selectedMonth"
              placeholder="Selecciona un mes"
              style="width: 160px; margin-right: 8px;"
              :options="monthOptions"
              allowClear
            />
            <a-button type="primary" @click="fetchData">Filtrar</a-button>
            <br>
          </div>
          <a-table
            :data-source="filteredDataCumple"
            :columns="cumpleanosColumns"
            :pagination="{ pageSize: 5 }"
            bordered
            size="small"
            :rowKey="(record, index) => `${record.nombre}-${index}`">
            <div
              slot="filterDropdown"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              style="padding: 8px">
              <a-input
                v-ant-ref="c => (searchInput = c)"
                :placeholder="`Search ${column.dataIndex}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block;"
                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
              >
                Search
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                Reset
              </a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template slot="customRender" slot-scope="text, record, index, column">
                <span v-if="searchText && searchedColumn === column.dataIndex">
                  <template
                    v-for="(fragment, i) in (text || '')
                      .toString()
                      .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                    <mark
                      v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                      :key="i"
                      class="highlight">{{ fragment }}</mark>
                    <template v-else>{{ fragment }}</template>
                  </template>
                </span>
              <template v-else>
                {{ text }}
              </template>
            </template>
          </a-table>
        </a-tab-pane>

        <a-tab-pane key="ausentismos" tab="Ausentismos">
          <div style="margin-bottom: 10px;">
            <a-range-picker v-model="dateRangeAuse"/>
            <a-button type="primary" @click="fetchData">Filtrar</a-button>
            <br>
          </div>
          <a-table
            :data-source="filteredDataAuse"
            :columns="ausentismosColumns"
            bordered
            size="small"
            :rowKey="(record, index) => `${record.nombre_empleado}-${index}`">
            <div
              slot="filterDropdown"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              style="padding: 8px">
              <a-input
                v-ant-ref="c => (searchInput = c)"
                :placeholder="`Search ${column.dataIndex}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block;"
                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
              >
                Search
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                Reset
              </a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template slot="customRender" slot-scope="text, record, index, column">
                <span v-if="searchText && searchedColumn === column.dataIndex">
                  <template
                    v-for="(fragment, i) in (text || '')
                      .toString()
                      .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                    <mark
                      v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                      :key="i"
                      class="highlight">{{ fragment }}</mark>
                    <template v-else>{{ fragment }}</template>
                  </template>
                </span>
              <template v-else>
                {{ text }}
              </template>
            </template>
          </a-table>
        </a-tab-pane>

        <a-tab-pane key="marcaciones" tab="Marcaciones">
          <div style="margin-bottom: 10px;">
            <a-range-picker v-model="dateRangeMarcaciones"/>
            <a-button type="primary" @click="fetchData">Filtrar</a-button>
            <br>
          </div>
          <a-table
            :data-source="filteredDataMarcaciones"
            :columns="marcacionesColumns"
            :pagination="{ pageSize: 5 }"
            bordered
            size="small"
            :rowKey="(record, index) => `${record.id_clock_mark}-${index}`">

            <!-- Filtro dropdown para marcaciones -->
            <div
              slot="filterDropdownMarcaciones"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              style="padding: 8px"
            >
              <a-input
                v-ant-ref="c => (searchInputMarcaciones = c)"
                :placeholder="`Search ${column.dataIndex}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block;"
                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearchMarcaciones(selectedKeys, confirm, column.dataIndex)"
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearchMarcaciones(selectedKeys, confirm, column.dataIndex)"
              >
                Search
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleResetMarcaciones(clearFilters)">
                Reset
              </a-button>
            </div>

            <!-- Icono de filtro -->
            <a-icon
              slot="filterIconMarcaciones"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />

            <!-- Renderer personalizado para texto con búsqueda -->
            <template slot="customRenderMarcaciones" slot-scope="text, record, index, column">
              <span v-if="searchTextMarcaciones && searchedColumnMarcaciones === column.dataIndex">
                <template
                  v-for="(fragment, i) in (text || '')
                    .toString()
                    .split(new RegExp(`(?<=${searchTextMarcaciones})|(?=${searchTextMarcaciones})`, 'i'))">
                  <mark
                    v-if="fragment.toLowerCase() === searchTextMarcaciones.toLowerCase()"
                    :key="i"
                    class="highlight">{{ fragment }}</mark>
                  <template v-else>{{ fragment }}</template>
                </template>
              </span>
              <template v-else>
                {{ text }}
              </template>
            </template>

            <!-- Renderer para tipo de marcación -->
            <span slot="tipoRendererMarcaciones" slot-scope="text">
              <a-tag :color="text==='ENTRADA' ? 'green' : 'red'">{{text}}</a-tag>
            </span>

            <!-- Renderer para acciones -->
            <template slot="accionesMarcaciones" slot-scope="text, record">
              <a-button
                size="small"
                type="link"
                icon="eye"
                @click="verDetalleMarcacion(record)"
                style="color:blue;"
                title="Ver Detalle">
              </a-button>
            </template>
          </a-table>
        </a-tab-pane>

        <a-tab-pane key="actividades" tab="Actividades">
          <div style="margin-bottom: 10px;">
            <a-range-picker v-model="dateRangeActi"/>
            <a-button type="primary" @click="fetchData">Filtrar</a-button>
            <br>
          </div>
          <a-table
            :data-source="filteredDataActi"
            :columns="actividadColumns"
            bordered
            size="small"
            :rowKey="(record, index) => `${record.id}-${index}`">
            <div
              slot="filterDropdown"
              slot-scope="{ setSelectedKeys, selectedKeys, confirm, clearFilters, column }"
              style="padding: 8px">
              <a-input
                v-ant-ref="c => (searchInput = c)"
                :placeholder="`Search ${column.dataIndex}`"
                :value="selectedKeys[0]"
                style="width: 188px; margin-bottom: 8px; display: block;"
                @change="e => setSelectedKeys(e.target.value ? [e.target.value] : [])"
                @pressEnter="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
              />
              <a-button
                type="primary"
                icon="search"
                size="small"
                style="width: 90px; margin-right: 8px"
                @click="() => handleSearch(selectedKeys, confirm, column.dataIndex)"
              >
                Search
              </a-button>
              <a-button size="small" style="width: 90px" @click="() => handleReset(clearFilters)">
                Reset
              </a-button>
            </div>
            <a-icon
              slot="filterIcon"
              slot-scope="filtered"
              type="search"
              :style="{ color: filtered ? '#108ee9' : undefined }"
            />
            <template slot="customRender" slot-scope="text, record, index, column">
                <span v-if="searchText && searchedColumn === column.dataIndex">
                  <template
                    v-for="(fragment, i) in (text || '')
                      .toString()
                      .split(new RegExp(`(?<=${searchText})|(?=${searchText})`, 'i'))">
                    <mark
                      v-if="fragment.toLowerCase() === searchText.toLowerCase()"
                      :key="i"
                      class="highlight">{{ fragment }}</mark>
                    <template v-else>{{ fragment }}</template>
                  </template>
                </span>
              <template v-else>
                {{ text }}
              </template>
            </template>
          </a-table>
        </a-tab-pane>
      </a-tabs>
    </a-spin>
  </a-modal>

  <!-- Modal para detalle de marcación -->
  <a-modal title="Detalle de Marcación"
           :visible="modalDetalleMarcacion"
           :footer="null"
           width="60%"
           :body-style="{ maxHeight: '70vh', overflowY: 'auto' }"
           centered
           @cancel="cerrarModalDetalleMarcacion">
    <div v-if="marcacionSeleccionada">
      <a-tabs defaultActiveKey="1" @change="onTabChange">
        <a-tab-pane key="1">
          <span slot="tab">
            <a-icon type="camera"/>
            Imagen
          </span>
          <div style="text-align: center; min-height: 250px;">
            <a-spin :spinning="loadingImagenMarcacion">
              <div v-if="imagenMarcacion">
                <img
                  :src="imagenMarcacion"
                  alt="Imagen de marcación"
                  style="max-width: 100%; max-height: 250px; border-radius: 8px; box-shadow: 0 4px 8px rgba(0,0,0,0.1); object-fit: contain;"
                />
              </div>
              <div v-else-if="!loadingImagenMarcacion" style="padding: 50px;">
                <a-empty description="No hay imagen disponible para esta marcación">
                  <a-icon type="camera" style="font-size: 48px; color: #ccc;"/>
                </a-empty>
              </div>
            </a-spin>
          </div>
        </a-tab-pane>

        <a-tab-pane key="2">
          <span slot="tab">
            <a-icon type="environment"/>
            Ubicación
          </span>
          <div style="min-height: 350px;">
            <a-spin :spinning="loadingMapaMarcacion">
              <div v-if="coordenadasMarcacion.lat && coordenadasMarcacion.lng">
                <!-- Indicadores de zoom -->
                <div
                  style="background: #f0f7ff; border: 1px solid #d6e4ff; border-radius: 6px; padding: 8px; margin-bottom: 8px; font-size: 12px; text-align: center;">
                  <span style="color: #1890ff;">
                    🔍 <strong>Controles de Zoom:</strong>
                    Scroll del mouse • Botones +/- • Doble click • Pellizcar (móvil)
                  </span>
                </div>

                <div id="mapaMarcacion"
                     style="height: 300px; width: 100%; border-radius: 8px; border: 1px solid #d9d9d9;"></div>

                <div style="margin-top: 10px; text-align: center;">
                  <div
                    style="display: flex; justify-content: space-between; align-items: center; background: #fafafa; padding: 8px; border-radius: 4px;">
                    <div>
                      <p style="margin: 0;"><strong>📍 Coordenadas:</strong></p>
                      <p style="margin: 0; font-size: 12px; color: #666;">
                        Lat: {{ coordenadasMarcacion.lat }} | Lng: {{ coordenadasMarcacion.lng }}
                      </p>
                      <p v-if="marcacionSeleccionada.physical_address" style="margin: 8px 0 0 0; font-size: 12px; color: #666;">
                        <strong>Dirección:</strong> {{ marcacionSeleccionada.physical_address }}
                      </p>
                    </div>
                    <div style="font-size: 11px; color: #999;">
                      Click en el marcador para<br>más opciones de navegación
                    </div>
                  </div>
                </div>
              </div>
              <div v-else-if="!loadingMapaMarcacion" style="padding: 50px; text-align: center;">
                <a-empty description="No hay coordenadas disponibles para esta marcación">
                  <a-icon type="environment" style="font-size: 48px; color: #ccc;"/>
                </a-empty>
              </div>
            </a-spin>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3">
            <span slot="tab">
              <a-icon type="file-text"/>
              Notas
            </span>
            <div style="min-height: 250px; padding: 16px;">
              <p><strong>{{$t('Observación')}}:</strong> {{ marcacionSeleccionada.observation || 'No hay info disponible' }}</p>
              <p><strong>{{$t('Comentario')}}:</strong> {{ marcacionSeleccionada.comment || 'No hay info disponible' }}</p>
            </div>
          </a-tab-pane>
      </a-tabs>
    </div>
  </a-modal>
  </div>
</template>

<script>
  import HttpUtil from '@/util/HttpUtil'
  import Mensajes from 'CustomModules/GlobalBPOCore/Util/Mensajes'
  import moment from 'moment'

  export default {
    data () {
      return {
        loading: false,
        activeTab: 'vacaciones',
        selectedMonth: null,
        monthOptions: [
          {label: 'Enero', value: '01'},
          {label: 'Febrero', value: '02'},
          {label: 'Marzo', value: '03'},
          {label: 'Abril', value: '04'},
          {label: 'Mayo', value: '05'},
          {label: 'Junio', value: '06'},
          {label: 'Julio', value: '07'},
          {label: 'Agosto', value: '08'},
          {label: 'Septiembre', value: '09'},
          {label: 'Octubre', value: '10'},
          {label: 'Noviembre', value: '11'},
          {label: 'Diciembre', value: '12'}
        ],
        dateRange: [],
        dateRangeCumple: [],
        dateRangeAuse: [],
        dateRangeMarcaciones: [],
        dateRangeActi: [],
        filteredData: [],
        filteredDataCumple: [],
        filteredDataAuse: [],
        filteredDataMarcaciones: [],
        filteredDataActi: [],
        searchText: '',
        searchInput: null,
        searchedColumn: '',
        searchTextMarcaciones: '',
        searchInputMarcaciones: null,
        searchedColumnMarcaciones: '',
        // Propiedades para modal de detalle de marcación
        modalDetalleMarcacion: false,
        marcacionSeleccionada: null,
        imagenMarcacion: null,
        loadingImagenMarcacion: false,
        loadingMapaMarcacion: false,
        coordenadasMarcacion: {
          lat: null,
          lng: null
        },
        mapaInstancia: null,
        mapaInicializado: false,
        vacacionesColumns: [
          {
            title: 'ID Empleado',
            dataIndex: 'id_emp',
            key: 'id_emp',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.id_emp
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Nombre',
            dataIndex: 'nombre',
            key: 'nombre',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.nombre
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Periodo Inicial',
            dataIndex: 'periodo_ini_desc',
            key: 'periodo_ini_desc',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.periodo_ini_desc
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Periodo Final',
            dataIndex: 'periodo_fin_desc',
            key: 'periodo_fin_desc',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.periodo_fin_desc
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Dias Pendientes Vac.',
            dataIndex: 'dias_pendientes_vac',
            key: 'dias_pendientes_vac',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              (record.dias_pendientes_vac || '')
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Dias Disfrutados',
            dataIndex: 'dias_disfrutados',
            key: 'dias_disfrutados',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              (record.dias_disfrutados || '')
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Dias Compensados',
            dataIndex: 'dias_compensados',
            key: 'dias_compensados',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              (record.dias_compensados || '')
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Fecha Ini. Disfrute',
            dataIndex: 'fecha_ini_disfrute',
            key: 'fecha_ini_disfrute',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              (record.fecha_ini_disfrute || '')
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Fecha Fin Disfrute',
            dataIndex: 'fecha_fin_disfrute',
            key: 'fecha_fin_disfrute',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              (record.fecha_fin_disfrute || '')
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          }
        ],
        cumpleanosColumns: [
          {
            title: 'ID Empleado',
            dataIndex: 'id_emp',
            key: 'id_emp',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.id_emp
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Nombre',
            dataIndex: 'nombre',
            key: 'nombre',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.nombre
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Dia Cumpleaños',
            dataIndex: 'f_dia_cumple',
            key: 'f_dia_cumple',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.f_dia_cumple
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          }
        ],
        ausentismosColumns: [
          {
            title: 'ID Empleado',
            dataIndex: 'id_emp',
            key: 'id_emp',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.id_emp
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Nombre',
            dataIndex: 'nombre_empleado',
            key: 'nombre_empleado',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.nombre_empleado
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Tipo Aus.',
            dataIndex: 'tipo_abs',
            key: 'tipo_abs',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.tipo_abs
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Fecha Inicio',
            dataIndex: 'abs_inicial',
            key: 'abs_inicial',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.abs_inicial
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Fecha Fin',
            dataIndex: 'abs_final',
            key: 'abs_final',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.abs_final
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Dias Aus.',
            dataIndex: 'abs_days_desc',
            key: 'abs_days_desc',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.abs_days_desc
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          }
        ],
        marcacionesColumns: [
          {
            title: 'ID Empleado',
            dataIndex: 'id_emp',
            key: 'id_emp',
            width: 120,
            sorter: (a, b) => a.id_emp.localeCompare(b.id_emp),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              record.id_emp
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Tipo',
            dataIndex: 'marking_type',
            key: 'marking_type',
            width: 100,
            align: 'center',
            sorter: (a, b) => a.marking_type.localeCompare(b.marking_type),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'tipoRendererMarcaciones'
            },
            onFilter: (value, record) =>
              record.marking_type
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Fecha',
            dataIndex: 'date_clock_mark',
            key: 'date_clock_mark',
            width: 110,
            sorter: (a, b) => new Date(a.date_clock_mark) - new Date(b.date_clock_mark),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              record.date_clock_mark
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Hora',
            dataIndex: 'time_clock_mark',
            key: 'time_clock_mark',
            width: 90,
            sorter: (a, b) => a.time_clock_mark.localeCompare(b.time_clock_mark),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              record.time_clock_mark
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Latitud',
            dataIndex: 'latitude',
            key: 'latitude',
            width: 110,
            sorter: (a, b) => parseFloat(a.latitude || 0) - parseFloat(b.latitude || 0),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              (record.latitude || '')
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Longitud',
            dataIndex: 'longitude',
            key: 'longitude',
            width: 110,
            sorter: (a, b) => parseFloat(a.longitude || 0) - parseFloat(b.longitude || 0),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              (record.longitude || '')
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Dirección'),
            dataIndex: 'physical_address',
            key: 'physical_address',
            width: 110,
            sorter: (a, b) => parseFloat(a.physical_address || 0) - parseFloat(b.physical_address || 0),
            scopedSlots: {
              filterDropdown: 'filterDropdownMarcaciones',
              filterIcon: 'filterIconMarcaciones',
              customRender: 'customRenderMarcaciones'
            },
            onFilter: (value, record) =>
              (record.physical_address || '')
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInputMarcaciones && this.searchInputMarcaciones.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Acciones',
            key: 'acciones',
            width: 100,
            align: 'center',
            scopedSlots: {customRender: 'accionesMarcaciones'}
          }
        ],
        actividadColumns: [
          {
            title: 'ID Empleado',
            dataIndex: 'id_emp',
            key: 'id_emp',
            width: 110,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.id_emp
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: 'Nombre',
            dataIndex: 'nombre_empleado',
            key: 'nombre_empleado',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.nombre_empleado
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Placa-Proyecto'),
            dataIndex: 'pp_desc',
            key: 'pp_desc',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.pp_desc
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Fecha Servicio'),
            dataIndex: 'sd_desc',
            key: 'sd_desc',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.sd_desc
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Lugar de Salida'),
            dataIndex: 'place_of_departure',
            key: 'place_of_departure',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.place_of_departure
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Hora Inicial Servicio'),
            dataIndex: 'start_time',
            key: 'start_time',
            width: 110,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.start_time
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Kilometraje Inicial'),
            dataIndex: 'initial_mileage',
            key: 'initial_mileage',
            width: 140,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.initial_mileage
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Descripción Primer Recorrido'),
            dataIndex: 'description_route',
            key: 'description_route',
            width: 200,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.description_route
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('¿Realiza otro recorrido?'),
            dataIndex: 'make_another_tour',
            key: 'make_another_tour',
            width: 130,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.make_another_tour
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Hora Final Servicio'),
            dataIndex: 'end_time',
            key: 'end_time',
            width: 110,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.end_time
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Hora Inicial Servicio'),
            dataIndex: 'final_mileage',
            key: 'final_mileage',
            width: 140,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.final_mileage
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Cliente'),
            dataIndex: 'cn_desc',
            key: 'cn_desc',
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.cn_desc
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Cant. Pasajeros Transportados'),
            dataIndex: 'number_passengers',
            key: 'number_passengers',
            width: 150,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.number_passengers
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          },
          {
            title: this.$t('Hora Descanso'),
            dataIndex: 'break_time',
            key: 'break_time',
            width: 120,
            scopedSlots: {
              filterDropdown: 'filterDropdown',
              filterIcon: 'filterIcon',
              customRender: 'customRender'
            },
            onFilter: (value, record) =>
              record.break_time
                .toString()
                .toLowerCase()
                .includes(value.toLowerCase()),
            onFilterDropdownVisibleChange: visible => {
              if (visible) {
                setTimeout(() => {
                  this.searchInput.focus()
                }, 0)
              }
            }
          }
        ]
      }
    },
    props: ['visible'],
    mounted () {
      this.http = new HttpUtil()
    },
    methods: {
      close () {
        this.$emit('ok')
      },
      async fetchData () {
        this.loading = true
        let endpoint = ''

        if (this.activeTab === 'vacaciones') {
          const [start, end] = this.dateRange.map(date => moment(date).format('YYYY-MM-DD'))

          endpoint = 'ss/dashboard/consultar_vac_my_team'
          this.http.getInstance().get(endpoint, {
            params: {
              f_ini: start,
              f_fin: end
            }
          }).then((response) => {
            this.filteredData = response.data
          }).catch(() => {
            Mensajes.error('Error', 'No fue posible cargar los totales empleados, contacte a mesa de ayuda.')
          }).then(() => {
            this.loading = false
          })
        } else if (this.activeTab === 'cumpleanos') {
          endpoint = 'ss/dashboard/consultar_cumple_my_team'
          this.http.getInstance().get(endpoint, {
            params: {
              mes_seleccionado: this.selectedMonth || ''
            }
          }).then((response) => {
            this.filteredDataCumple = response.data
          }).catch(() => {
            Mensajes.error('Error', 'No fue posible cargar los totales empleados, contacte a mesa de ayuda.')
          }).then(() => {
            this.loading = false
          })
        } else if (this.activeTab === 'ausentismos') {
          const [start, end] = this.dateRangeAuse.map(date => moment(date).format('YYYY-MM-DD'))

          endpoint = 'ss/dashboard/consultar_ausentismos_my_team'
          this.http.getInstance().get(endpoint, {
            params: {
              f_ini: start,
              f_fin: end
            }
          }).then((response) => {
            this.filteredDataAuse = response.data
          }).catch(() => {
            Mensajes.error('Error', 'No fue posible cargar los totales empleados, contacte a mesa de ayuda.')
          }).then(() => {
            this.loading = false
          })
        } else if (this.activeTab === 'marcaciones') {
          const [start, end] = this.dateRangeMarcaciones.map(date => moment(date).format('YYYY-MM-DD'))

          endpoint = 'ss/dashboard/my_team_marcaciones'
          this.http.getInstance().get(endpoint, {
            params: {
              f_ini: start,
              f_fin: end
            }
          }).then((response) => {
            this.filteredDataMarcaciones = response.data.data || response.data
          }).catch(() => {
            Mensajes.error('Error', 'No fue posible cargar las marcaciones, contacte a mesa de ayuda.')
          }).then(() => {
            this.loading = false
          })
        } else if (this.activeTab === 'actividades') {
          const [start, end] = this.dateRangeActi.map(date => moment(date).format('YYYY-MM-DD'))

          endpoint = 'ss/dashboard/actividades_geo_my_team'
          this.http.getInstance().get(endpoint, {
            params: {
              f_ini: start,
              f_fin: end
            }
          }).then((response) => {
            this.filteredDataActi = response.data
            console.log(this.filteredDataActi)
          }).catch(() => {
            Mensajes.error('Error', 'No fue posible cargar las actividades, contacte a mesa de ayuda.')
          }).then(() => {
            this.loading = false
          })
        }
      },
      handleSearch (selectedKeys, confirm, dataIndex) {
        confirm()
        this.searchText = selectedKeys[0]
        this.searchedColumn = dataIndex
      },
      handleReset (clearFilters) {
        clearFilters()
        this.searchText = ''
      },
      handleSearchMarcaciones (selectedKeys, confirm, dataIndex) {
        confirm()
        this.searchTextMarcaciones = selectedKeys[0]
        this.searchedColumnMarcaciones = dataIndex
      },
      handleResetMarcaciones (clearFilters) {
        clearFilters()
        this.searchTextMarcaciones = ''
      },
      verDetalleMarcacion (record) {
        this.abrirModalDetalleMarcacion(record)
      },
      async abrirModalDetalleMarcacion (marcacion) {
        this.marcacionSeleccionada = marcacion
        this.modalDetalleMarcacion = true
        this.imagenMarcacion = null
        this.coordenadasMarcacion = {
          lat: null,
          lng: null
        }
        this.mapaInicializado = false

        // Cargar imagen y establecer coordenadas
        this.cargarImagenMarcacion(marcacion.id_clock_mark)

        // Cargar Leaflet antes de establecer coordenadas si hay coordenadas válidas
        if (marcacion.latitude && marcacion.longitude) {
          try {
            await this.cargarLeaflet()
          } catch (error) {
            console.warn('No se pudo cargar Leaflet, usando fallback:', error)
          }
        }

        this.establecerCoordenadasMarcacion(marcacion)
      },
      onTabChange (activeKey) {
        // Si cambian al tab de "Ubicación" (key="2") y hay coordenadas disponibles y no se ha inicializado
        if (activeKey === '2' && this.coordenadasMarcacion.lat && this.coordenadasMarcacion.lng && !this.mapaInicializado) {
          this.mapaInicializado = true
          // Dar un pequeño delay para que el tab se renderice completamente
          setTimeout(() => {
            this.inicializarMapa()
          }, 200)
        }
      },
      cerrarModalDetalleMarcacion () {
        this.modalDetalleMarcacion = false
        this.marcacionSeleccionada = null
        this.imagenMarcacion = null
        this.coordenadasMarcacion = {
          lat: null,
          lng: null
        }

        // Destruir instancia del mapa si existe
        if (this.mapaInstancia) {
          // Si es un mapa de Leaflet, usar su método remove()
          if (typeof this.mapaInstancia.remove === 'function') {
            this.mapaInstancia.remove()
          }
          this.mapaInstancia = null
        }

        // Resetear flag de inicialización para permitir nueva inicialización en próxima apertura
        this.mapaInicializado = false
      },
      cargarImagenMarcacion (marcacionId) {
        this.loadingImagenMarcacion = true

        this.http.getInstance().get(`ss/dashboard/marcaciones/${marcacionId}/imagen`, {
          responseType: 'arraybuffer'
        })
          .then((response) => {
            if (response.data && response.data.byteLength > 0) {
              let blob = new Blob([response.data], {type: response.headers['content-type'] || 'image/jpeg'})
              this.imagenMarcacion = window.URL.createObjectURL(blob)
            }
          })
          // eslint-disable-next-line handle-callback-err
          .catch((error) => {
            // No mostramos error ya que es normal que algunas marcaciones no tengan imagen
          })
          .then(() => {
            this.loadingImagenMarcacion = false
          })
      },
      establecerCoordenadasMarcacion (marcacion) {
        this.loadingMapaMarcacion = true

        // Usar las coordenadas del record de la marcación
        if (marcacion.latitude && marcacion.longitude) {
          this.coordenadasMarcacion = {
            lat: parseFloat(marcacion.latitude),
            lng: parseFloat(marcacion.longitude)
          }

          // Ya no inicializamos el mapa automáticamente - esperamos a que el usuario cambie al tab
          setTimeout(() => {
            this.loadingMapaMarcacion = false
          }, 300)
        } else {
          // Si no hay coordenadas en el record, intentar cargar desde el servidor
          this.http.getInstance().get(`ss/dashboard/marcaciones/${marcacion.id_clock_mark}/coordenadas`)
            .then((response) => {
              if (response.data && response.data.latitud && response.data.longitud) {
                this.coordenadasMarcacion = {
                  lat: parseFloat(response.data.latitud),
                  lng: parseFloat(response.data.longitud)
                }

                // Ya no inicializamos el mapa automáticamente - esperamos a que el usuario cambie al tab
              }
            })
            .catch((error) => {
              console.error('Error al cargar coordenadas:', error)
              // No mostramos error ya que es posible que algunas marcaciones no tengan coordenadas
            })
            .then(() => {
              this.loadingMapaMarcacion = false
            })
        }
      },
      // Método para cargar Leaflet dinámicamente
      async cargarLeaflet () {
        return new Promise((resolve, reject) => {
          // Si Leaflet ya está cargado, resolver inmediatamente
          if (typeof L !== 'undefined') {
            resolve()
            return
          }

          // Verificar si ya se está cargando
          if (document.getElementById('leaflet-css') || document.getElementById('leaflet-js')) {
            // Esperar a que se complete la carga
            const checkLeaflet = () => {
              if (typeof L !== 'undefined') {
                resolve()
              } else {
                setTimeout(checkLeaflet, 100)
              }
            }
            checkLeaflet()
            return
          }

          // Cargar CSS de Leaflet
          const linkCss = document.createElement('link')
          linkCss.id = 'leaflet-css'
          linkCss.rel = 'stylesheet'
          linkCss.href = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.css'
          linkCss.integrity = 'sha256-p4NxAoJBhIIN+hmNHrzRCf9tD/miZyoHS5obTRR9BMY='
          linkCss.crossOrigin = 'anonymous'
          document.head.appendChild(linkCss)

          // Cargar JS de Leaflet
          const scriptJs = document.createElement('script')
          scriptJs.id = 'leaflet-js'
          scriptJs.src = 'https://unpkg.com/leaflet@1.9.4/dist/leaflet.js'
          scriptJs.integrity = 'sha256-20nQCchB9co0qIjJZRGuk2/Z9VM+kNiyxNV1lvTlZBo='
          scriptJs.crossOrigin = 'anonymous'

          scriptJs.onload = () => {
            resolve()
          }

          scriptJs.onerror = () => {
            reject(new Error('Error al cargar Leaflet'))
          }

          document.head.appendChild(scriptJs)
        })
      },
      inicializarMapa (intentos = 0) {
        if (!this.coordenadasMarcacion.lat || !this.coordenadasMarcacion.lng) {
          return
        }

        // Esperar múltiples ciclos para asegurar que el DOM esté completamente listo
        this.$nextTick(() => {
          setTimeout(() => {
            const mapElement = document.getElementById('mapaMarcacion')
            if (!mapElement) {
              if (intentos < 3) {
                setTimeout(() => this.inicializarMapa(intentos + 1), 500)
                return
              }
              this.mostrarFallbackMapa()
              return
            }

            // Verificar que el elemento tenga dimensiones válidas y esté visible
            const rect = mapElement.getBoundingClientRect()
            const computedStyle = window.getComputedStyle(mapElement)

            // Verificar si el elemento está realmente visible
            const isVisible = rect.width > 0 && rect.height > 0 &&
              computedStyle.display !== 'none' &&
              computedStyle.visibility !== 'hidden' &&
              computedStyle.opacity !== '0'

            if (!isVisible) {
              if (intentos < 5) {
                setTimeout(() => this.inicializarMapa(intentos + 1), 800)
                return
              }
              this.mostrarFallbackMapa()
              return
            }

            // Usar Leaflet como librería principal de mapas
            if (typeof L !== 'undefined') {
              try {
                this.inicializarLeafletMap()
              } catch (error) {
                console.error('Error al ejecutar inicializarLeafletMap:', error)
                this.mostrarFallbackMapa()
              }
            } else {
              this.mostrarFallbackMapa()
            }
          }, 300)
        })
      },
      inicializarLeafletMap () {
        const mapElement = document.getElementById('mapaMarcacion')
        if (!mapElement) {
          this.mostrarFallbackMapa()
          return
        }

        try {
          // Extraer valores primitivos de las coordenadas reactivas de Vue
          const lat = parseFloat(this.coordenadasMarcacion.lat)
          const lng = parseFloat(this.coordenadasMarcacion.lng)

          // Verificar que las coordenadas sean válidas
          if (isNaN(lat) || isNaN(lng)) {
            throw new Error(`Coordenadas inválidas: lat=${lat}, lng=${lng}`)
          }

          // Limpiar el contenedor del mapa
          mapElement.innerHTML = ''

          // Crear el mapa con Leaflet usando valores primitivos
          // eslint-disable-next-line no-undef
          this.mapaInstancia = L.map('mapaMarcacion', {
            center: [lat, lng],
            zoom: 16,
            minZoom: 1,        // Permitir zoom muy alejado para ver contexto amplio
            maxZoom: 20,       // Permitir zoom muy cercano para ver detalles
            zoomControl: true, // Mostrar controles de zoom
            scrollWheelZoom: true, // Permitir zoom con scroll del mouse
            doubleClickZoom: true, // Permitir zoom con doble click
            touchZoom: true,   // Permitir zoom táctil en móviles
            zoomSnap: 0.5,     // Permitir zoom en incrementos de 0.5 para más granularidad
            zoomDelta: 0.5     // Cambio de zoom por cada click en los controles
          })

          // Agregar el layer de OpenStreetMap
          // eslint-disable-next-line no-undef
          L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '© <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors',
            maxZoom: 20,      // Asegurar que los tiles estén disponibles hasta zoom 20
            minZoom: 1,       // Tiles disponibles desde zoom 1
            keepBuffer: 2     // Mantener tiles en buffer para navegación más fluida
          }).addTo(this.mapaInstancia)

          // Crear icono personalizado para el marcador
          // eslint-disable-next-line no-undef
          const marcadorIcono = L.divIcon({
            className: 'custom-marcador',
            html: '<div style="background-color: #ff4d4f; width: 20px; height: 20px; border-radius: 50%; border: 3px solid white; box-shadow: 0 2px 4px rgba(0,0,0,0.3);"></div>',
            iconSize: [26, 26],
            iconAnchor: [13, 13]
          })

          // Agregar marcador en la ubicación
          // eslint-disable-next-line no-undef
          const marker = L.marker([lat, lng], {icon: marcadorIcono})
            .addTo(this.mapaInstancia)
            .bindPopup(`
              <div style="text-align: center; min-width: 200px;">
                <strong>📍 Ubicación de Marcación</strong><br><br>
                <div style="margin: 8px 0;">
                  <strong>Coordenadas:</strong><br>
                  Lat: ${lat}<br>
                  Lng: ${lng}
                </div>
                <div style="margin: 12px 0;">
                  <button onclick="window.open('https://maps.google.com/?q=${lat},${lng}', '_blank')"
                     style="background: #4285f4; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; margin: 2px;">
                    🗺️ Ver en Google Maps
                  </button><br>
                  <button onclick="window.open('https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}&zoom=18', '_blank')"
                     style="background: #7ebc6f; color: white; border: none; padding: 6px 12px; border-radius: 4px; cursor: pointer; margin: 2px;">
                    🌍 Ver en OpenStreetMap
                  </button>
                </div>
                <div style="font-size: 11px; color: #666; margin-top: 8px;">
                  💡 Usa scroll o +/- para hacer zoom<br>
                  Doble click para zoom rápido
                </div>
              </div>
            `)

          // Abrir popup automáticamente
          marker.openPopup()

          // Agregar control de escala
          // eslint-disable-next-line no-undef
          L.control.scale({
            metric: true,
            imperial: false,
            position: 'bottomleft'
          }).addTo(this.mapaInstancia)

          // Forzar redimensionamiento del mapa después de un breve delay
          setTimeout(() => {
            if (this.mapaInstancia) {
              this.mapaInstancia.invalidateSize()
            }
          }, 100)
        } catch (error) {
          console.error('Error al inicializar mapa con Leaflet:', error)
          this.mostrarFallbackMapa()
        }
      },
      mostrarFallbackMapa () {
        const mapElement = document.getElementById('mapaMarcacion')
        if (!mapElement) {
          return
        }

        mapElement.innerHTML = `
          <div style="background: #f0f0f0; height: 100%; display: flex; align-items: center; justify-content: center; border: 1px solid #ddd; border-radius: 8px; min-height: 300px;">
            <div style="text-align: center; padding: 20px;">
              <div style="font-size: 48px; margin-bottom: 15px; color: #1890ff;">📍</div>
              <div style="font-size: 16px; font-weight: bold; margin-bottom: 10px;">Ubicación de Marcación</div>
              <div style="margin-bottom: 15px; color: #666;">
                <div>Latitud: ${this.coordenadasMarcacion.lat}</div>
                <div>Longitud: ${this.coordenadasMarcacion.lng}</div>
              </div>
              <div style="margin-bottom: 15px;">
                <button onclick="window.open('https://maps.google.com/?q=${this.coordenadasMarcacion.lat},${this.coordenadasMarcacion.lng}', '_blank')"
                   style="color: #1890ff; text-decoration: none; background: #e6f7ff; padding: 8px 16px; border-radius: 4px; border: 1px solid #1890ff; cursor: pointer;">
                  🗺️ Ver en Google Maps
                </button>
              </div>

              <div style="font-size: 12px; color: #999;">
                El mapa interactivo no se pudo cargar
              </div>
            </div>
          </div>
        `
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/SelfService/pages/Dashboard/ModalNovMyTeam.vue